import { render, staticRenderFns } from "./departmentTreeDialog.vue?vue&type=template&id=5326a8b4&scoped=true&"
import script from "./departmentTreeDialog.vue?vue&type=script&lang=js&"
export * from "./departmentTreeDialog.vue?vue&type=script&lang=js&"
import style0 from "./departmentTreeDialog.vue?vue&type=style&index=0&id=5326a8b4&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5326a8b4",
  null
  
)

export default component.exports